import { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useApp } from "@/contexts/AppContext";
import { supabase } from "@/lib/supabase";
import { Users, TrendingUp, Clock, CheckCircle, Copy } from "lucide-react";

export default function AffiliatePage() {
  const { user, authLoading } = useApp();
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!user) return;
    supabase.rpc("my_affiliate_summary").then(({ data }) => { setData(data); setLoading(false); });
  }, [user?.id]);

  if (authLoading) return null;
  if (!user) return <Navigate to="/login" />;

  const link = data?.code ? `https://www.agroaluga.com.br/?ref=${data.code}` : "";
  function copy() { navigator.clipboard.writeText(link); setCopied(true); setTimeout(() => setCopied(false), 2000); }
  const fmt = (v) => "R$ " + Number(v || 0).toFixed(2).replace(".", ",");

  return (
    <div className="container mx-auto px-4 py-8 max-w-2xl">
      <h1 className="text-2xl font-heading font-bold mb-6">Area do Afiliado</h1>

      {loading ? (
        <p className="text-muted-foreground">Carregando...</p>
      ) : !data?.is_affiliate ? (
        <div className="bg-card border border-border rounded-xl p-8 text-center">
          <Users className="h-10 w-10 mx-auto mb-3 text-muted-foreground opacity-50" />
          <p className="text-muted-foreground">Voce ainda nao e um afiliado AgroAluga.</p>
          <p className="text-sm text-muted-foreground mt-2">Entre em contato pelo e-mail agroaluga@outlook.com para saber como participar.</p>
        </div>
      ) : (
        <div className="space-y-6">
          <div className="bg-card border border-border rounded-xl p-5">
            <p className="text-xs text-muted-foreground mb-2">Seu link de indicacao</p>
            <div className="flex items-center gap-2">
              <code className="flex-1 text-sm bg-secondary px-3 py-2 rounded-md truncate">{link}</code>
              <button onClick={copy} className="flex items-center gap-1 text-sm font-medium bg-primary text-primary-foreground px-3 py-2 rounded-md hover:bg-primary/90">
                <Copy className="h-4 w-4" /> {copied ? "Copiado!" : "Copiar"}
              </button>
            </div>
            <p className="text-xs text-muted-foreground mt-2">
              Comissao de {data.percent}% por {data.months} meses sobre cada assinatura indicada.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="bg-card border border-border rounded-xl p-5">
              <Users className="h-5 w-5 text-primary mb-2" />
              <p className="text-2xl font-bold">{data.indicados}</p>
              <p className="text-xs text-muted-foreground">Indicacoes com assinatura</p>
            </div>
            <div className="bg-card border border-border rounded-xl p-5">
              <TrendingUp className="h-5 w-5 text-primary mb-2" />
              <p className="text-2xl font-bold">{fmt(data.total)}</p>
              <p className="text-xs text-muted-foreground">Comissao total</p>
            </div>
            <div className="bg-card border border-border rounded-xl p-5">
              <Clock className="h-5 w-5 text-amber-500 mb-2" />
              <p className="text-2xl font-bold text-amber-600">{fmt(data.pendente)}</p>
              <p className="text-xs text-muted-foreground">A receber</p>
            </div>
            <div className="bg-card border border-border rounded-xl p-5">
              <CheckCircle className="h-5 w-5 text-green-600 mb-2" />
              <p className="text-2xl font-bold text-green-700">{fmt(data.pago)}</p>
              <p className="text-xs text-muted-foreground">Ja recebido</p>
            </div>
          </div>

          <p className="text-xs text-muted-foreground text-center">
            Os pagamentos de comissao sao feitos conforme combinado. Duvidas: agroaluga@outlook.com
          </p>
        </div>
      )}
    </div>
  );
}
